import React, { useState, useEffect } from 'react';
import ChatPreview from '../ChatPreview';
import FormPreview from './FormPreview';
import SlidePreview from './SlidePreview';
import GraderPreview from './GraderPreview';
import LessonPlanPreview from './LessonPlanPreview'
import FlashcardsPreview from './FlashcardsPreview'
import './toolCard.css';

const ToolCard = ({ title, icon, previewType, tagline, onClick }) => {
  const [hovered, setHovered] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  // Detect if using a touch device
  useEffect(() => {
    const detectTouch = () => {
      setIsTouchDevice(true);
      // Remove listeners after detection
      window.removeEventListener('touchstart', detectTouch);
    };

    window.addEventListener('touchstart', detectTouch);
    
    // Check if device doesn't support hover
    if (window.matchMedia('(hover: none)').matches) {
      setIsTouchDevice(true);
    }

    return () => {
      window.removeEventListener('touchstart', detectTouch);
    };
  }, []);

  const renderPreview = () => {
    switch (previewType) {
      case 'chat': return <ChatPreview />;
      case 'form': return <FormPreview />;
      case 'slides': return <SlidePreview />;
      case 'grader': return <GraderPreview />;
      case 'lesson': return <LessonPlanPreview />;
      case 'flashcards': return <FlashcardsPreview />;
      default: return null;
    }
  };
  
  // Function to get icon background color based on tool type
  const getIconBackground = () => {
    switch (title) {
      case 'GraderBot': return 'rgba(89, 128, 100, 0.1)';
      case 'Quiz Generator': return 'rgba(106, 90, 140, 0.1)';
      case '5D Lesson Planner': return 'rgba(82, 143, 155, 0.1)';
      case 'Presentation Generator': return 'rgba(150, 120, 70, 0.1)';
      case 'Flashcards': return 'rgba(220, 202, 152, 0.1)';
      default: return 'rgba(220, 202, 152, 0.1)';
    }
  };

  const handleCardClick = (e) => {
    // For touch devices, toggle preview on first tap, navigate on second tap
    if (isTouchDevice) {
      if (!showPreview) {
        setShowPreview(true);
        e.preventDefault(); // Prevent navigation on first tap
        return;
      } else {
        // On second tap, allow navigation
        onClick();
      }
    } else {
      // For non-touch devices, navigate immediately
      onClick();
    }
  };
  
  const handleMouseEnter = () => {
    if (!isTouchDevice) {
      setHovered(true);
    }
  };
  
  const handleMouseLeave = () => {
    if (!isTouchDevice) {
      setHovered(false);
    }
  };

  return (
    <div
      className={`tool-card-wrapper ${hovered || showPreview ? 'hovered' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleCardClick}
    >
      <div className="tool-card-front">
        <div 
          className="icon-container"
          style={{ backgroundColor: getIconBackground() }}
        >
          <img src={icon} alt={`${title} icon`} className="tool-icon" />
        </div>
        <h3>{title}</h3>
        <p>{tagline}</p>
        <span className="learn-more">
          {isTouchDevice ? 'Tap to preview' : 'Click to explore'}
        </span>
      </div>
      {(hovered || showPreview) && (
        <div className="tool-card-preview">
          {renderPreview()}
          <div className="preview-overlay">
            <button className="preview-button">
              {isTouchDevice ? 'Tap again to launch' : 'Launch Tool'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ToolCard;
